// Imports
// ------
import React from 'react';
import styled, { css } from 'styled-components';
import { Section, P, H2, Div } from '@reuse';
import { breakup } from '@break';
import { Row, Column } from 'react-foundation';
import ReactHtmlParser, { processNodes } from 'react-html-parser';

// Styles
// ------
const Jacket = styled(Section)`
    width: 100%;
    margin-bottom: ${props => props.theme.padS};

    ${breakup.medium`
        margin-bottom: ${props => props.theme.padM};
    `}

    ${breakup.large`
        margin-bottom: ${props => props.theme.padL};
    `}
`;

const ContentJacket = styled(Div)`
    margin-bottom: 3.6rem;
    ${breakup.large` margin-bottom: 6rem; `}

    &:last-child { margin-bottom: 0; }
`;

const Text = styled(P)`
    ${props => props.list === "true" ? css`
        ${breakup.large` margin-top: 5px; `}
    ` : null }
`;

const Heading = styled(H2)``;

const StyledList = styled.ul`
    list-style: none;
    position: relative;
`;

const ListItem = styled.li`
    position: relative;
    display: block;
    margin-bottom: 6rem;

    ${breakup.large` margin-bottom: 6rem; `}

    &:last-child {
        margin-bottom: 0;
    }
`;

const Icon = styled.i`
    position: relative;
    display: block;
    width: 3.6rem;
    height: 3.6rem;
    background-color: ${props => props.theme.bc5};
    border-radius: 100%;
    margin-bottom: 2.4rem;

    ${breakup.large`
        width: 4.8rem;
        height: 4.8rem;
    `}
`;

const Svg = styled.svg`
    ${props => props.theme.talign}
    width: 2rem;
    height: 2rem;
    fill: white;

    ${breakup.large`
        width: 2.4rem;
        height: 2.4rem;
    `}
`;



// Component
// ------
function transform(node, index) {

    if (node.type === "tag" && node.name === "p") {
        return (
            <ContentJacket key={index}>
                <Row isExpanded>
                    <Column small={12} medium={10} large={8} centerOnMedium>
                        <Text>{processNodes(node.children, transform)}</Text>
                    </Column>
                </Row>
            </ContentJacket>
        )
    }

    if (node.type === "tag" && node.name === "h1") {
        return (
            <ContentJacket key={index}>
                <Row isExpanded>
                    <Column small={12} medium={10} large={8} centerOnMedium>
                        <Heading>{processNodes(node.children, transform)}</Heading>
                    </Column>
                </Row>
            </ContentJacket>
        )
    }

    if (node.type === "tag" && node.name === "h2") {
        return (
            <ContentJacket key={index}>
                <Row isExpanded>
                    <Column small={12} medium={10} large={8} centerOnMedium>
                        <Heading>{processNodes(node.children, transform)}</Heading>
                    </Column>
                </Row>
            </ContentJacket>
        )
    }

    if (node.type === "tag" && node.name === "h3") {
        return (
            <ContentJacket key={index}>
                <Row isExpanded>
                    <Column small={12} medium={10} large={8} centerOnMedium>
                        <Heading>{processNodes(node.children, transform)}</Heading>
                    </Column>
                </Row>
            </ContentJacket>
        )
    }

    if (node.type === "tag" && node.name === "h4") {
        return (
            <ContentJacket key={index}>
                <Row isExpanded>
                    <Column small={12} medium={10} large={8} centerOnMedium>
                        <Heading>{processNodes(node.children, transform)}</Heading>
                    </Column>
                </Row>
            </ContentJacket>
        )
    }

    if (node.type === "tag" && node.name === "h5") {
        return (
            <ContentJacket key={index}>
                <Row isExpanded>
                    <Column small={12} medium={10} large={8} centerOnMedium>
                        <Heading>{processNodes(node.children, transform)}</Heading>
                    </Column>
                </Row>
            </ContentJacket>
        )
    }
    
    if (node.type === "tag" && node.name === "ul") {
        return (
            <ContentJacket key={index}>
                <StyledList>{processNodes(node.children, transform)}</StyledList>
            </ContentJacket>
        )
    }

    if (node.type === "tag" && node.name === "li") {
        return (
            <ListItem key={index}>
                <Row isExpanded>
                    {/* Icon */}
                    <Column small={3} medium={1} pushOnMedium={1} pushOnLarge={2}>
                        <Icon>
                            <Svg viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg">
                                <polygon points="11 27.829 1.171 18 4 15.171 11 22.171 29 4.171 31.829 7 11 27.829"/>
                            </Svg>
                        </Icon>
                    </Column>

                    {/* Content */}
                    <Column small={9} pullOnMedium={1} large={7} pullOnLarge={2}>
                        <Text list="true">{processNodes(node.children, transform)}</Text>
                    </Column>
                </Row>
            </ListItem>
        )
    }
}

const options = {
    decodeEntities: true,
    transform
};

const Content = ({content}) => (
    <Jacket bc1 pad>
        {ReactHtmlParser(content, options)}
    </Jacket>
);

export default Content;